import fetch from '@/utils/fetch'

/**
 * 获取展览列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getExhibitionList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_hot_exhibition_list',
    method: 'post',
    data
  })
}
/**
 * 获取展览购票列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getTicketList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_ticket_list',
    method: 'post',
    data
  })
}

/**
 * 获取展览详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getExhibitionDetail(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_exhibition_detail',
    method: 'post',
    data
  })
}

/**
 * 获取笔记列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getNoteList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_hot_note_list',
    method: 'post',
    data
  })
}

/**
 * 获取笔记详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getNoteDetail(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_note_detail',
    method: 'post',
    data
  })
}

/**
 * 获取视频笔记
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getVideoNoteList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/recommand/video',
    method: 'post',
    data
  })
}

/**
 * 获取作品列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getArtworkList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_artwork_list',
    method: 'post',
    data
  })
}

/**
 * 获取作品详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getArtworkDetail(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/official/get_artwork_detail',
    method: 'post',
    data
  })
}

/**
 * 获取手机区号
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getPhoneCode() {
  return fetch({
    url: '/api_user/service/w/account/get_area_code',
    method: 'get',
    data: {}
  })
}
/**
 * 获取图片验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getImageCode(sessionId) {
  return `${
    process.env.VUE_APP_BASE_API
  }/api_user/service/w/nwr/account/verifycode/image?sessionId=${sessionId}`
}

/**
 * 邮箱注册
 *
 * @export
 * @param {any} data
 * @returns
 */
export function mailRegister(data) {
  return fetch({
    url: '/api_user/service/w/account/mail_register',
    method: 'post',
    data
  })
}

/**
 * 手机注册
 *
 * @export
 * @param {any} data
 * @returns
 */
export function phoneRegister(data) {
  return fetch({
    url: '/api_user/service/w/account/phone_register',
    method: 'post',
    data
  })
}

/**
 * 发送验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function sendCode(data) {
  return fetch({
    url: '/api_user/service/w/account/verifycode/send',
    method: 'post',
    data
  })
}
/**
 * 忘记密码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function resetPassword(data) {
  return fetch({
    url: '/api_user/service/w/account/reset_password',
    method: 'post',
    data
  })
}

/**
 * 邮箱登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function mailLogin(data) {
  return fetch({
    url: '/api_user/service/w/account/mail_login',
    method: 'post',
    data
  })
}

/**
 * 手机登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function phoneLogin(data) {
  return fetch({
    url: '/api_user/service/w/account/phone_login',
    method: 'post',
    data
  })
}

/**
 * 手机登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getManager(data) {
  return fetch({
    url: '/api_user/service/w/account/get_organ_manager_list',
    method: 'post',
    data
  })
}

/**
 * 第三方登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function thirdLogin(data) {
  return fetch({
    url: '/api_user/service/w/account/third_login',
    method: 'post',
    data
  })
}

/**
 * 第三方注册
 *
 * @export
 * @param {any} data
 * @returns
 */
export function thirdRegister(data) {
  return fetch({
    url: '/api_user/service/w/account/third_register',
    method: 'post',
    data
  })
}

/**
 * 退出登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function logout(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/account/logout',
    method: 'post',
    data: {}
  })
}

/**
 * 获取分享页token
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getShareAppToken(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/account/share/token',
    method: 'post',
    data
  })
}
/**
 * 更新session心跳接口
 *
 * @export
 * @param {any} data
 * @returns
 */
export function heartbeat(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/heart',
    method: 'post',
    data,
    notLogin: true
  })
}
